import type { UserEffectSetting } from 'src/types/Deco';

import { APIClientType } from '.';

/**
 * 이펙트 정보를 반환하는 API Service
 *
 * 기존에 이펙트 정보를 가져가던 플로우를 간소화하기 위해서 새로 만들어졌습니다.
 * 기존 절차에서 구매 절차를 제거하고, 처음부터 EffectSpecification 을 포함한 정보를
 * 내려줍니다.
 *
 * @since 950
 */
export interface EffectServiceType {
  /**
   * 매치 중에 사용 중인 이펙트에 대한 정보를 보낸다.
   *
   * @param matchId 연관된 match Id
   * @param userEffectSetting 현재 사용 중인 이펙트 정보
   * @throws AuthenticationException 유저가 로그인되어 있지 않은 경우
   * @throws IllegalArgumentException 잘못된 값을 보낸 경우
   * @since 950
   */
  reportInMatchEffectUsage: (
    matchId: string,
    userEffectSetting: UserEffectSetting
  ) => Promise<void>;
}

export class EffectService implements EffectServiceType {
  private client: APIClientType;

  constructor(customClient: APIClientType) {
    this.client = customClient;
  }

  public reportInMatchEffectUsage = async (
    matchId: string,
    userEffectSetting: UserEffectSetting
  ) => {
    return this.client.call<void, Parameters<typeof this.reportInMatchEffectUsage>>({
      method: 'reportInMatchEffectUsage',
      data: [matchId, userEffectSetting],
    });
  };
}
